// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"40036b6f27ff3f3c54ac","223":"ef4bdae54e0ea7dc2391","293":"05deb4b1cc1b35b87455"}[chunkId] + ".js";
};